export default __webpack_public_path__ + "static/media/about1.a2a29d24.jpg";